import { createClient } from '@supabase/supabase-js';
import { isNative } from './capacitor';
import { PUBLIC_HOST } from '../utils/hosts';

// On Capacitor, window.location.origin is capacitor://localhost — useless for
// real network calls. Pin the URL to the public host on native so the
// Supabase client can actually reach GoTrue.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
  || (isNative
    ? `${PUBLIC_HOST}/supabase`
    : (typeof window !== 'undefined' ? `${window.location.origin}/supabase` : `${PUBLIC_HOST}/supabase`));
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Only create client if configured
let supabase = null;

if (supabaseAnonKey) {
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      storageKey: 'supabase-auth',
      detectSessionInUrl: false
    }
  });
}

// Helper to check if Supabase auth is enabled
export const isSupabaseAuthEnabled = () => {
  return process.env.REACT_APP_USE_SUPABASE_AUTH === 'true' && supabase !== null;
};

export default supabase;
